<div class="exercicio-list">
  <section>
    <app-table
        [listColumns]="listColumns"
        [listData]="data"
        [listActions]="listActions"
        [filterForm]="filterForm"
        [canCreate]="false"
        [canChange]="false"
        [canExport]="false"
        [canView]="true"
        title="Meus Suportes"
        filterField="pergunta"
    >
  </app-table>
  </section>
</div>
<app-loading [loader]="isLoading"></app-loading>